/* Auto-rotating promotions banner slider (image + video slides). */
if (!customElements.get('promo-banner-slider')) {
  customElements.define(
    'promo-banner-slider',
    class PromoBannerSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll(':scope > .promo-slide'));
        this.dots = Array.from(this.querySelectorAll('.promo-slider-dot'));
        this.prevBtn = this.querySelector('.promo-slider-arrow--prev');
        this.nextBtn = this.querySelector('.promo-slider-arrow--next');
        this.current = 0;

        if (this.slides.length <= 1) return;

        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        if (this.dataset.autoplay === 'true') {
          this.speed = parseInt(this.dataset.speed, 10) || 6000;
          this.start();
          if (this.dataset.pause === 'true') {
            this.addEventListener('mouseenter', () => this.stop());
            this.addEventListener('mouseleave', () => this.start());
          }
        }
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.go(this.current + 1), this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }

      go(index) {
        const total = this.slides.length;
        this.current = (index + total) % total;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
      }
    }
  );
}